import {useState, useEffect} from 'react';
import debounce from 'lodash.debounce';

const getWindowDimensions = () => {
  const {innerWidth: width, innerHeight: height} = window;

  return {
    width,
    height,
    isMobile: width < 768,
  };
};

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', debounce(handleResize, 200));

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
